/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { isAuthenticatedUser } from 'js/lib/user';

import { Grid } from '@coursera/cds-core';

import type { WesLogoProps } from 'bundles/composable-page-header-enterprise/components/WesLogoGridItem';
import WesLogo from 'bundles/composable-page-header-enterprise/components/WesLogoGridItem';
import { useEnterpriseMyPageHeader } from 'bundles/composable-page-header-enterprise/contexts/EnterpriseMyPageHeaderContext';
import DefaultLoggedInEnterpriseMobileMenuConfig from 'bundles/composable-page-header-enterprise/module-renderers/DefaultLoggedInEnterpriseMobileMenuConfig';
import LoggedOutWesMobileMenuConfig from 'bundles/composable-page-header-enterprise/module-renderers/LoggedOutWesMobileMenuConfig';
import type { CommonNavProps } from 'bundles/composable-page-header-enterprise/types/wesHeader';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import MobileAccountMenuGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileAccountMenuGridItem';
import MobileMenuIconGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuIconGridItem';
import AccountMenuConfig from 'bundles/composable-page-header/components/mobile-menu-items/AccountMenuConfig';
import { useIsOrgScopedHome } from 'bundles/unified-common/hooks/useIsOrgScopedHome';

const styles = {
  menuIcon: css`
    margin-right: 0;
  `,
};

export interface WesMobileNavProps extends WesLogoProps, CommonNavProps {
  hideMetaNav?: boolean;
}
function WesMobileNav(props: WesMobileNavProps) {
  const enterpriseMyPageHeader = useEnterpriseMyPageHeader();
  const isLoggedIn = isAuthenticatedUser();
  const isOrgScoped = useIsOrgScopedHome();

  const loggedInMobileMenu = isOrgScoped ? (
    <MobileAccountMenuGridItem
      isCourseraPlusLearner={!!enterpriseMyPageHeader.isCourseraPlusLearner}
      menuConfig={
        <AccountMenuConfig
          naptimeManagedThirdPartyOrganizations={enterpriseMyPageHeader.naptimeManagedThirdPartyOrganizations}
          canViewEducatorAdminLink={enterpriseMyPageHeader.canViewEducatorAdminLink}
          hasCheatingIncidents={enterpriseMyPageHeader.hasCheatingIncidents}
          currentOrganization={enterpriseMyPageHeader.naptimeChosenOrganization}
          currentDegree={enterpriseMyPageHeader.chosenDegree}
          degrees={enterpriseMyPageHeader.enrolledDegreePrograms}
          organizations={enterpriseMyPageHeader.naptimeOrganizationsWithProgramEnrollments}
        />
      }
    />
  ) : (
    <MobileMenuIconGridItem
      menuConfig={
        <DefaultLoggedInEnterpriseMobileMenuConfig
          currentOrganization={enterpriseMyPageHeader.naptimeChosenOrganization}
          enrolledOrganizations={enterpriseMyPageHeader.naptimeOrganizationsWithProgramEnrollments}
          currentProgram={enterpriseMyPageHeader.currentPageProgram}
          enrolledDegreePrograms={enterpriseMyPageHeader.enrolledDegreePrograms}
          enrolledEnterprisePrograms={enterpriseMyPageHeader.enrolledEnterprisePrograms}
          chosenDegree={enterpriseMyPageHeader.chosenDegree}
          chosenEnterpriseProgram={enterpriseMyPageHeader.chosenEnterpriseProgram}
          hasEnrolledPrograms={!!enterpriseMyPageHeader.hasEnrolledPrograms}
          naptimeManagedThirdPartyOrganizations={enterpriseMyPageHeader.naptimeManagedThirdPartyOrganizations}
          hasCheatingIncidents={enterpriseMyPageHeader.hasCheatingIncidents}
          canViewEducatorAdminLink={enterpriseMyPageHeader.canViewEducatorAdminLink}
        />
      }
      homeLogo={<WesLogo logoType={props.logoType} />}
      css={styles.menuIcon}
    />
  );

  return (
    <MainNavigationWrapper>
      <Grid item alignItems="center" container justifyContent="space-between">
        <Grid item>
          <WesLogo logoType={props.logoType} />
        </Grid>
        <Grid item>
          {isLoggedIn ? (
            loggedInMobileMenu
          ) : (
            <MobileMenuIconGridItem
              menuConfig={
                <LoggedOutWesMobileMenuConfig
                  hideMetaNav={props.hideMetaNav}
                  renderLoggedOutCtas={props.renderLoggedOutCta}
                />
              }
              homeLogo={<WesLogo logoType={props.logoType} />}
              css={styles.menuIcon}
            />
          )}
        </Grid>
      </Grid>
    </MainNavigationWrapper>
  );
}

export default WesMobileNav;
